import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      { path: '/home', name: '首页', component: () => import('@/views/home') },
      { path: '/news', name: '咨询', component: () => import('@/views/home/NewsList.vue') },
      { path: '/campus/:productId', name: '智慧校园', component: () => import('@/views/campus/index.vue') },
      { path: '/case/:type/:id', name: '客户案例', component: () => import('@/components/CaseDetail/index.vue') },
      { path: '/smart', name: '学职星AI', component: () => import('@/views/smart') },
      { path: '/honor', name: '案例/荣誉', component: () => import('@/views/honor') },
      { path: '/about', name: '关于明杉', component: () => import('@/views/about') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() { return { x: 0, y: 0 } }
})

router.afterEach(to => {
  document.title = `明杉科技 - ${to.name}`
})

export default router
